import { RoutePaths } from '@shared/utils';
import { Button, Icon, Modal, Text } from '@shared/widgets';
import TickInCircleIcon from '@assets/icons/tick-in-circle.svg';
import ArrowIcon from '@assets/icons/arrow.svg';

interface VerifiedRecipientModalProps {
  isOpen: boolean;
  description?: string;
  buttonTitle?: string;
  onClose?: () => void;
}

export const VerifiedRecipientModal = (props: VerifiedRecipientModalProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} className='px-[30px] py-9' headerClassName='mb-0' width='468px'>
      <div className='flex flex-col gap-8'>
        <div className='flex flex-col gap-2'>
          <Icon color='green' icon={<TickInCircleIcon className='mx-auto' />} />
          <Text center tag='h3' size='3xl'>
            Recipient verified
          </Text>
        </div>
        <Text center size='lg' color='secondary-light'>
          The name provided matches the name of the beneficiary
        </Text>
        {props.description && (
          <Text center size='lg'>
            {props.description}
          </Text>
        )}
        {props.onClose && (
          <Button color='primary' onClick={props.onClose}>
            {props.buttonTitle || 'OK'}
          </Button>
        )}
        {!props.onClose && (
          <Button color='outlined' to={RoutePaths.payments.onNavigate()}>
            Back to the payments page
            <Icon icon={<ArrowIcon />} color='inherit' />
          </Button>
        )}
      </div>
    </Modal>
  );
};
